const donateActionTypes = {
  BANK_TRANSFER_DONATE_START: "BANK_TRANSFER_DONATE_START",
  BANK_TRANSFER_DONATE_SUCCESS: "BANK_TRANSFER_DONATE_SUCCESS",
  BANK_TRANSFER_DONATE_FAILED: "BANK_TRANSFER_DONATE_FAILED",
  PAYMENT_DONATE_START: "PAYMENT_DONATE_START",
  PAYMENT_DONATE_SUCCESS: "PAYMENT_DONATE_SUCCESS",
  PAYMENT_DONATE_FAILED: "PAYMENT_DONATE_FAILED",
  PAYMENT_TOKEN_START: "PAYMENT_TOKEN_START",
  PAYMENT_TOKEN_SUCCESS: "PAYMENT_TOKEN_SUCCESS",
  PAYMENT_TOKEN_FAILED: "PAYMENT_TOKEN_FAILED",
  ALL_DONATE_START: "ALL_DONATE_START",
  ALL_DONATE_SUCCESS: "ALL_DONATE_SUCCESS",
  ALL_DONATE_FAILED: "ALL_DONATE_FAILED",
  DONATE_STATUS_START: "DONATE_STATUS_START",
  DONATE_STATUS_SUCCESS: "DONATE_STATUS_SUCCESS",
  DONATE_STATUS_FAILED: "DONATE_STATUS_FAILED",
};

export default donateActionTypes;
